import React from 'react'
import { Html, useProgress } from '@react-three/drei'
import { Grid } from '@mui/material';

const CanvasLoader = () => {

  const {progress} = useProgress();


  return (
    <Grid container
    position="relative"
    // height="100vh"
    // width="100vw"
    // backgroundColor="red"
    // zIndex="999"
    >
      
      <span
        className='canvas-load'
      >
        <p
          style={{
            fontSize: 30,
            color: "#f1f1f1",
            fontWeight: 880,
            marginTop: 40
          }}
        >
          
          {progress.toFixed(2)}%
        </p>

      </span>


    
    </Grid>
    
  )
}

export default CanvasLoader